<ng-container *ngIf="memberCard$ | async as memberCard; else loadingRef">
  <div class="member-card bg-primary text-white border p-3">
    <fgb-member-card-details [memberCard]="memberCard" cardImage="assets/images/Logos/Redbullslogo.png"></fgb-member-card-details>
  </div>
</ng-container>

<ng-template #loadingRef>
  <fgb-loading></fgb-loading>
</ng-template>
